export default "/img/GL.fbe8a64c413d663881ceda06240f5974.png";